module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "number-stepper"
  }, [_c('b-input-group', {
    staticClass: "stepper-input"
  }, [_c('b-button', {
    staticClass: "-prev",
    on: {
      "click": _vm.innerStepDown
    }
  }, [_vm._v("◀")]), _vm._v(" "), _c('b-form-input', {
    staticClass: "-value",
    class: _vm.inputClasses,
    attrs: {
      "value": _vm.leftPaddedValue
    },
    on: {
      "input": _vm.handleInputValue
    }
  }), _vm._v(" "), _c('b-button', {
    staticClass: "-next",
    on: {
      "click": _vm.innerStepUp
    }
  }, [_vm._v("▶")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4577b062"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/atoms/ErcoNumberStepper.vue
// module id = 618
// module chunks = 0